import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
/*import "bootstrap/dist/css/bootstrap.min.css";*/
import { getProjects } from "../../services/api"; // Función para obtener todos los proyectos
import Breadcrumbs from "../../components/BreadCrumbs";
import { formatDate, formatCurrency } from "../../utils/utils";

const ProjectList = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true); // Estado para manejar la carga
  const [error, setError] = useState(null); // Estado para manejar errores

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await getProjects();
        if (response) {
          // Verifica si la respuesta tiene datos
          setProjects(response);
        } else {
          setProjects([]); // Establece proyectos como vacío si no hay datos
        }
      } catch (error) {
        setError("Error al obtener proyectos");
        console.error("Error al obtener proyectos", error);
      } finally {
        setLoading(false); // Se ejecuta independientemente de si hubo éxito o error
      }
    };

    fetchProjects();
  }, []); // El efecto solo se ejecutará una vez, cuando el componente se monte

  if (loading) {
    return <p>Cargando...</p>; // Muestra un mensaje de carga mientras se espera la respuesta
  }

  if (error) {
    return <p>{error}</p>; // Muestra el mensaje de error si ocurrió algún problema
  }

  // Definir las rutas para los breadcrumbs
  const breadcrumbPaths = [
    { name: "Dashboard", url: "/dashboard" },
    { name: "Projects", url: "/dashboard/projects" },
  ];

  return (
    <>
      <h3>Lista de Proyectos</h3>
      <Breadcrumbs paths={breadcrumbPaths} />
      <Link to="create" className="btn btn-primary mb-3">
        Crear Proyecto
      </Link>

      {projects && projects.length > 0 ? (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Fecha de Inicio</th>
              <th>Fecha de Fin</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {projects.map((project) => (
              <tr key={project.proyectos_id}>
                <td>{project.proyectos_id}</td>
                <td>{project.nombre}</td>
                <td>{project.descripcion}</td>
                <td>{formatDate(project.fecha_inicio)}</td>
                <td>{formatDate(project.fecha_fin)}</td>
                <td>{project.estado}</td>
                <td>
                  {/* Enlace a los casos de prueba del proyecto */}
                  <Link
                    to={`${project.proyectos_id}/tests`}
                    className="btn btn-info me-2"
                  >
                    Ver Casos de Prueba
                  </Link>
                  <Link
                    to={`update/${project.proyectos_id}`}
                    className="btn btn-secondary"
                  >
                    Editar
                  </Link>
                  <Link
                    to={`delete/${project.proyectos_id}`}
                    className="btn btn-danger"
                  >
                    Eliminar
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No hay proyectos disponibles.</p>
      )}
    </>
  );
};

export default ProjectList;
